/**
 * Trilho de camadas do celular recolhido (pedido do usuário, 09/10/2026): vira
 * um botão só, e o mapa fica livre na borda esquerda. Lembrado no navegador,
 * como a legenda recolhida. O `<html data-trilho-recolhido>` faz o
 * `--trilho-largura` (index.css) voltar a um botão também deitado, e o que fica
 * à direita do trilho (`--trilho-fim`) chega mais para a borda.
 */
import { create } from 'zustand';

const CHAVE = 'amaview:trilho-recolhido';

function ler(): boolean {
  try {
    return globalThis.localStorage?.getItem(CHAVE) === '1';
  } catch {
    return false;
  }
}

function gravar(recolhido: boolean): void {
  try {
    if (recolhido) globalThis.localStorage?.setItem(CHAVE, '1');
    else globalThis.localStorage?.removeItem(CHAVE);
  } catch {
    // navegação privada / armazenamento bloqueado: só não lembra
  }
}

function marcarNoDocumento(recolhido: boolean): void {
  if (typeof document === 'undefined') return;
  if (recolhido) document.documentElement.dataset.trilhoRecolhido = '';
  else delete document.documentElement.dataset.trilhoRecolhido;
}

interface TrilhoState {
  recolhido: boolean;
  /** `lembrar` falso: só nesta visita (o "Próximos dias" recolhe o trilho sem mudar a preferência). */
  setRecolhido: (recolhido: boolean, lembrar?: boolean) => void;
}

export const useTrilhoStore = create<TrilhoState>()((set) => ({
  recolhido: ler(),
  setRecolhido: (recolhido, lembrar = true) => {
    if (lembrar) gravar(recolhido);
    marcarNoDocumento(recolhido);
    set({ recolhido });
  },
}));

marcarNoDocumento(useTrilhoStore.getState().recolhido);

/**
 * O trilho está recolhido? (fora do React: enquadramento do mapa). No
 * "Próximos dias" ele fica aberto, com os botões da previsão, qualquer que
 * seja a preferência (`<html data-modo-previsao>`, da store da previsão).
 */
export const trilhoRecolhido = (): boolean =>
  useTrilhoStore.getState().recolhido && !(typeof document !== 'undefined' && document.documentElement.hasAttribute('data-modo-previsao'));
